<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: scroll" tabindex="-1" @click="onClose">
      <div class="modal-dialog modal-dialog-centered" @click.stop="">
        <div class="modal-content">
          <div class="modal-header">
            <button @click="onClose" type="button" class="close" data-bs-dismiss="modal" aria-label="Close">×</button>
          </div>
          <div class="modal-body">
            <ValidatedSelect
              rules="required"
              label="Reason for marking red:"
              id="cancelReason"
              v-model="reason"
              :options="cancelReasons"
            />
            <label>Note:</label>
            <b-form-input placeholder="" v-model="noteInput" required></b-form-input>

            <div class="ban-section mt-3">
              <b-form-checkbox variant="primary" v-model="banEnabled">
                Ban this lead
              </b-form-checkbox>

              <div v-if="banEnabled" class="ban-options mt-2 ml-4">
                <b-form-checkbox variant="primary" v-model="banIp">IP Address</b-form-checkbox>
                <b-form-checkbox variant="primary" v-model="banEmail">Email</b-form-checkbox>
                <b-form-checkbox variant="primary" v-model="banPhone">Phone Number</b-form-checkbox>
              </div>
            </div>

            <div class="text-right">
              <b-button @click="markRed" type="button" class="mt-3" variant="primary" :disabled="!reason">Mark as Bad</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import ValidatedSelect from '@/components/shared/ValidatedSelect';
import cancelReasonsMixin from '@/mixins/cancelReasons';

export default {
  name: 'WhyRedModal',
  components: {
    ValidatedSelect,
  },
  mixins: [cancelReasonsMixin],
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    leadId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      noteInput: null,
      reason: null,
      banEnabled: false,
      banIp: false,
      banEmail: false,
      banPhone: false,
    };
  },
  methods: {
    async markRed() {
      //this.$store.dispatch('leads/updatePriority', { leadId: this.leadId, priority: 4 });
      //await ApiClient.leads.notes.post({ leadId: this.leadId, body: { note: this.noteInput } });
      const body = {
        cancelReasonId: this.reason,
        cancelReasonNote: this.noteInput,
      };

      if (this.banEnabled) {
        const ban = [];
        if (this.banIp) ban.push('ip');
        if (this.banEmail) ban.push('email');
        if (this.banPhone) ban.push('phone');
        if (ban.length > 0) {
          body.ban = ban;
        }
      }

      await ApiClient.leads.cancel({ id: this.leadId, body });
      this.onClose();
    },
  },
};
</script>

<style lang="scss" scoped>
h5 {
  margin: 0;
}

.outter-modal {
  position: absolute;
  z-index: 1089;
}
</style>
